import { isArray, isEmpty, isNumber } from '../../../utils'
import components from './edit-item.component'
/*
* 获取当前验证状态 className
* @errorMsg {String} 当前控件的错误提示  null->还没有进行过验证 ''->验证通过 否则验证不通过
* @return   {null | String} 根据状态返回className
*/
export const getValidateStatus = function (errorMsg) {
  switch (errorMsg) {
    case null:
      return null
    case '':
      return 'is-success'
    default:
      return 'is-error'
  }
}
/*
* 获取当前验证状态图标 className
* @errorMsg {String} 当前控件的错误提示  null->还没有进行过验证 ''->验证通过 否则验证不通过
* @return   {null | String} 根据状态返回className
*/
export const getValidateStatusIcon = function (errorMsg) {
  switch (errorMsg) {
    case null:
      return null
    case '':
      return 'el-icon-circle-check'
    default:
      return 'el-icon-circle-close'
  }
}
/*
  根据required 和 type[number, minLength, maxLength, regexp]去返回对应的校验函数
 */
const setValidateByType = function (rule, item) {
  // 如果已经有自定义校验函数那么，不需要给他设置了
  if (rule.validate) return
  // 支持{required: true}写法
  rule.required && (rule.type = 'required')
  // 支持{minLength: 1}写法
  if (rule.minLength) {
    rule.type = 'minLength'
    rule.value = rule.minLength
  }
  // 支持{maxLength: 10}写法
  if (rule.maxLength) {
    rule.type = 'maxLength'
    rule.value = rule.maxLength
  }
  rule.validate = (() => {
    switch (rule.type) {
      case 'required':
        return function (item) {
          return !isEmpty(item.value)
        }
      case 'number':
        return function (item) {
          return item.value !== '' && isNumber(+item.value)
        }
      case 'minLength':
        return function (item) {
          return !(item.value.length < rule.value)
        }
      case 'maxLength':
        return function (item) {
          return !(item.value.length > rule.value)
        }
      case 'regexp':
        return function (item) {
          return rule.value.test(item.value)
        }
      default:
        return function (item) {
          return true
        }
    }
  })()
}
/**
 * 把所有校验对象转换成{事件： 对象}的格式
 * [{trigger, msg, validate }...] => {trigger: validateFn(包含提示信息)}
 */
export const transformValidate = (vm, item) => {
  if (!item.rules) return {}
  let rules = isArray(item.rules) ? item.rules : [item.rules]
  let rulesObj = {}
  rules.forEach(rule => {
    // first 首先把所有type都转成validate的形式统一处理
    setValidateByType(rule, item)
    // 把trigger转成数组 如果没有则自动填充默认的trigger事件
    let triggers = isArray(rule.trigger) ? rule.trigger : [rule.trigger || components[item.type].validateEvent || 'change']
    triggers.forEach(trigger => {
      // 因为trigger可能会重复，需要记录上一次的trigger
      let lastTrigger = rulesObj[trigger]
      rulesObj[trigger] = () => {
        // 先校验之前的trigger,
        if (lastTrigger && !lastTrigger()) { // 存在并且验证失败需要停止校验。
          return false
        }
        if (!rule.validate.call(item, item)) { // validate返回false校验不通过
          vm.errorMsg = rule.msg
          return false
        } else { // validate返回true校验通过
          vm.errorMsg = ''
          return true
        }
      }
    })
  })
  return rulesObj
}
